import { Accordion, Container } from 'react-bootstrap';

export default function FaqSection() {
  return (
    <section className="py-5 bg-dark text-white" id="faq">
      <Container>
        <h2 className="mb-4 text-center">Preguntas Frecuentes</h2>
        <Accordion defaultActiveKey={null} alwaysOpen={false}>
          <Accordion.Item eventKey="0">
            <Accordion.Header>¿Para cuántas personas es Cardúmenes?</Accordion.Header>
            <Accordion.Body>
              Cardúmenes está diseñado exclusivamente para 2 jugadores.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>¿Cuánto dura una partida?</Accordion.Header>
            <Accordion.Body>
              En promedio, una partida dura entre 25 y 45 minutos.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>¿Es apto para todas las edades?</Accordion.Header>
            <Accordion.Body>
              El juego está recomendado para adultos mayores de 14 años. No tiene contenido inapropiado, pero requiere táctica, planificación y estrategia.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>¿Qué incluye la caja del juego?</Accordion.Header>
            <Accordion.Body>
              El juego incluye 116 cartas: 2 Mazos (Azul y Verde) idénticos de 40, 32 Cartas de Mercado, 4 Cartas de Aturdir / Paralizar. y dos dados D4.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>¿Dónde puedo conseguirlo?</Accordion.Header>
            <Accordion.Body>
              Podés comprar Cardúmenes en nuestra tienda online. 
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    </section>
  );
}
